<template>
  <main v-if="!customer.info === false" :class="{'boxPadding': isBox}">
    <customer-info :loading="false" />
    <tab-header :current="currentTab"/>
    <div class="tab-content">
      <div class="container-fluid">
        <div class="tab-pane pt-0 active show"
        :class="{
          'section-loading': isLoading_1
        }">
          <div v-if="loanList.length > 0">
            <div
            v-for="(loan, i) in loanList"
            :key="`loan-item-${i}`">
              <h4 class="mt-5 mb-3">擔保品地址：{{loan.address}}</h4>
              <div class="insurance-row row">
                <table class="table insurance-green">
                  <thead>
                    <tr>
                      <th>貸款帳號</th>
                      <th>貸放日期</th>
                      <th width="50">契約狀況</th>
                      <th class="text-right">貸款金額</th>
                      <th class="text-right">貸款餘額</th>
                      <th class="text-right">貸款總期數</th>
                      <th>火險效力</th>
                      <th>下期應繳日</th>
                      <th class="text-right">下期利率</th>
                      <th class="text-right">下期應繳金額</th>
                      <th width="50" class="text-right">下期期數</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                    v-for="(item, j) in loan.data"
                    :key="`loan-tr-${i}-${j}`">
                      <td>
                        <a class="link text-underline" @click="openTheLoanModal(item)">{{item.account}}</a>
                      </td>
                      <td>{{item.checkAt | dateFormat }}</td>
                      <td>{{item.status}}</td>
                      <td class="text-right">{{item.amount | numberFormat}}</td>
                      <td class="text-right">{{item.last | numberFormat}}</td>
                      <td class="text-right">{{item.series}}</td>
                      <td>{{item.fireRisk}}</td>
                      <td>{{item.nextPayAt | dateFormat}}</td>
                      <td class="text-right">{{item.nextRate}}%</td>
                      <td class="text-right">{{item.nextFee | numberFormat}}</td>
                      <td class="text-right">{{item.nextSeries}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div v-else
          class="text-center" colspan="6">
            <h3 class="mb-3">無貸款資料</h3>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <loan-modal
    :loan="selectedLoan"
    :open="loanModalOpen"
    @close="panelClose('loanModalOpen')"/>
    
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';
import { commonMixin } from '../../mixins/common';
import { queryHousingLoans } from '../../service';

import Avatar from '../../components/Avatar';
import CustomerInfo from '../components/CustomerDetail/CustomerInfo';
import TabHeader from '../components/CustomerDetail/TabHeader';
import LoanModal from '../components/LoanModal';

const customer = {
  info: {
    // lv: 3,
    // gender: 0,
    // familyLeader: true,
    // birthday: '19750809',
    // name: '陳怡君',
    // mobile: '0922133647',
    // phone: '02-28223521',
    // fax: '02-28223521',
    // ID: 'A223456789',
    // office_phone: '02-28223521',
    // address: ['112', '台北市', '北投區', '光明路251號'],
    // office_address: ['104', '台北市', '內湖區', '陽光街288號'],
  },
  data: {
    // remark: '要被意保險',
    // lineid: 'Amy0315',
    // career: '公務員',
    // agency: '總統府',
    // marriage: '已婚',
    // relate: '要被意保險',
    // introducer: '林怡君',
    // email: 'Green@tree.com.tw',
    // education: '研究所'
  },
  iaa: {
    // mobile: '0922133647',
    // phone: '02-28223521',
    // address: ['112', '台北市', '北投區', '光明路251號'],
    // email: 'Green@tree.com.tw'
  },
  financial: {
    // household_income: '80萬~100萬',
    // personal_income: '80萬~100萬',
    // monthly_invest: 10,
    // finance_tool: '股票',
    // houseloan: 0,
    // housing: '自宅',
    // vehicle: '機車、汽車'
  },
  decline: [],
  family: [
    // {
    //   // link: 1,
    //   // name: '陳怡君',
    //   // gender: 0,
    //   // identity: 'A223456789',
    //   // role: '戶長',
    //   // birthday: '19600809'
    // },
    // {
    //   name: '王大進',
    //   gender: 1,
    //   identity: 'A223456789',
    //   role: '配偶',
    //   birthday: '19600809'
    // },
    // {
    //   name: '王潔心',
    //   gender: 0,
    //   identity: 'A223456789',
    //   role: '子女',
    //   birthday: '19600809'
    // },
    // {
    //   name: '簡沛文',
    //   gender: -1,
    //   identity: 'A223456789',
    //   role: '其他',
    //   birthday: '19600809'
    // },
    // {
    //   link: 1,
    //   name: '陳潔妮',
    //   gender: -1,
    //   identity: 'A223456789',
    //   role: '其他',
    //   birthday: '19600809'
    // },
    // {
    //   name: '端木王大進',
    //   gender: -1,
    //   identity: 'A223456789',
    //   role: '其他',
    //   birthday: '19600809'
    // }
  ],
  record: [
  //   // {
  //   //   year: 94,
  //   //   data: []
  //   // },
  //   // {
  //   //   year: 95,
  //   //   data: []
  //   // },
  //   // {
  //   //   year: 96,
  //   //   data: []
  //   // },
  //   // {
  //   //   year: 97,
  //   //   data: []
  //   // },
  //   // {
  //   //   year: 98,
  //   //   data: [
  //   //     {
  //   //       date: '98/12/25',
  //   //       title: '聖誕節送禮',
  //   //       tags: ['增員關係', '車險預約單', '易Call保', '贈送媒體']
  //   //     }
  //   //   ]
  //   // },
  //   // {
  //   //   year: 99, data: []
  //   // },
  //   // {
  //   //   year: 100, data: []
  //   // },
  //   // {
  //   //   year: 101, data: []
  //   // },
  //   // {
  //   //   year: 102, data: []
  //   // },
  //   // {
  //   //   year: 103, data: []
  //   // },
  //   // {
  //   //   year: 104, data: []
  //   // },
  //   {
  //     year: 105,
  //     data: [
  //       {
  //         date: '105/12/25',
  //         title: '聖誕節送禮',
  //         tags: ['增員關係', '車險預約單', '易Call保', '贈送媒體']
  //       },
  //       {
  //         date: '105/06/08',
  //         title: '聖誕節送禮',
  //         tags: ['增員關係', '車險預約單', '易Call保', '贈送媒體']
  //       }
  //     ]
  //   },
  //   {
  //     year: 106,
  //     data: [
  //       {
  //         date: '106/12/25',
  //         title: '',
  //         tags: ['增員關係', '車險預約單', '易Call保', '贈送媒體']
  //       }
  //     ]
  //   },
  //   {
  //     year: 107, data: []
  //   }
  ],
  // note: "一般市面上的老百姓，家中有新生兒，潛在客戶，一般市面上的老百姓，家中有新生兒，潛在客戶。"
}

// const loan = [
//   {
//     address: '106台北市大安區仁愛路四段296號1樓',
//     data: [
//       {
//         account: 'A0623409',
//         checkAt: '105/12/07',
//         status: '正常',
//         amount: 193667874,
//         last: 98447738,
//         series: 240,
//         fireRisk: '正常',
//         nextPayAt: '107/02/12',
//         nextRate: 1.99,
//         nextFee: 282930,
//         nextSeries: 23,
//         address: '106台北市大安區仁愛路四段296號1樓'
//       },
//       {
//         account: 'A0636679',
//         checkAt: '107/06/17',
//         status: '正常',
//         amount: 3667874,
//         last: 1447738,
//         series: 120,
//         fireRisk: '正常',
//         nextPayAt: '107/02/17',
//         nextRate: 2.65,
//         nextFee: 12930,
//         nextSeries: 5,
//         address: '106台北市大安區仁愛路四段296號1樓'
//       }
//     ]
//   },
//   {
//     address: '106台北市大安區信義路三段107號4樓',
//     data: [
//       {
//         account: 'A0623409',
//         checkAt: '105/12/07',
//         status: '正常',
//         amount: 193667874,
//         last: 98447738,
//         series: 240,
//         fireRisk: '正常',
//         nextPayAt: '107/02/12',
//         nextRate: 1.99,
//         nextFee: 282930,
//         nextSeries: 23
//       }
//     ]
//   }
// ]

export default {
  name: 'CustomerDetail7',
  mixins: [commonMixin],
  data () {
    return {
      isLoading_1: false,
      currentTab: 0,
      customer: customer,
      loanList: [],
      selectedLoan: null,
      loanModalOpen: false
    }
  },
  components: { 
    Avatar, CustomerInfo, TabHeader, // basic component
    LoanModal 
  },
  computed: {
    ...mapGetters(['BaseUrl', 'UserInfo', 'CustInfo']),
    isBox() {
      // 判斷是否為 box
      return this.UserInfo.userType === 'box';
    }
  },
  watch: {
    "$route": function() {
      this.initCustomerDetail7()
    }
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    openTheLoanModal(item) {
      this.selectedLoan = item
      this.panelOpen('loanModalOpen')
    },
    initCustDetail7() {
      this.isLoading_1 = true
      queryHousingLoans(this.UserInfo.id, this.CustInfo.ID).then(result => {
        if(result.body && result.body.length > 0) {
          let bufferList = result.body.map(item => {
            return {
              address: item.GAGE_ADDR,  //GAGE_ADDR 擔保品地址
              account: item.LOAN_ID,  //LOAN_ID 貸款帳號
              checkAt: item.LOAN_DATE,  //LOAN_DATE 貸放日期
              status: item.LOAN_STATUS_NM,  //LOAN_STATUS_NM 契約效力
              amount: Number(item.LOAN_AMT),  //LOAN_AMT 貸款金額
              last: Number(item.SPR_AMT),  //SPR_AMT 本金餘額
              series: item.LOAN_PERIOD,  //LOAN_PERIOD 借款期數
              fireRisk: item.FIRE_STATUS,  //FIRE_STATUS 火險狀態
              nextPayAt: item.NEXT_PAYDT,  //NEXT_PAYDT 下期應繳日
              nextRate: item.RATE,  //RATE 下期利率
              nextFee: Number(item.DUTY_PAYMT),  //DUTY_PAYMT 下期應繳金額
              nextSeries: item.NEXT_PAY_TERM,  //NEXT_PAY_TERM 下期期數
              getintCode: item.GETINT_CODE, //收費代號
              intList: item.intList.length == 0 ? []: item.intList.map(listItem => {
                return {
                  series: listItem.PAY_TERM,  //PAY_TERM 期數
                  last: Number(listItem.LAST_PRINCIPAL),  //LAST_PRINCIPAL 繳款前本金餘額
                  shouldPayAt: listItem.DUTY_PAYDT,  //DUTY_PAYDT 應繳日期
                  payAt: listItem.REAL_PAYDT,  //REAL_PAYDT 實繳日期
                  rate: listItem.INT_RATE,  //INT_RATE 適用年利率
                  renge: Number(listItem.RENEGE), //違約金
                  delayInt: Number(listItem.DELAY_INT), //延滯息
                  interest: Number(listItem.INTEREST), //本期利息
                  principal: Number(listItem.PRINCIPAL),  //PRINCIPAL 本期本金
                  payment: listItem.PAY_TYPE_NM  //PAY_TYPE_NM 繳款方式
                }
              })
            }
          })
          let groupByAddress = new Map
          bufferList.forEach((item, index) => {
            if(groupByAddress.has(item.address)) {
              groupByAddress.get(item.address).push(item)
            } else {
              groupByAddress.set(item.address, [item])
            }
          })
          this.loanList = Array.from(groupByAddress.values()).map(addressGroup => {
            return {
              address: addressGroup[0].address,
              data: addressGroup
            }
          })
          this.isLoading_1 = false
        } else {
          this.loanList = []
          this.isLoading_1 = false
        }
      })
    }
  },
  beforeMount () {
    let routeNumber = (this.$route.name.split(/-/g)).reverse()
    this.currentTab = Number(routeNumber[0])
  },
  async mounted () {
    this.initCustDetail7()
  }
}
</script>

<style scoped>
.boxPadding {
  padding-top: 0px !important;
}
</style>